// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1WwUm","dragIcon":"Choice_dragIcon__kU1dN","left":"Choice_left__2pNnT","input":"Choice_input__3f3J9"};